import styled from 'styled-components';
import { InputUnderline } from '../../../component/input/InputUnderline';
import { useEffect, useState } from 'react';
import {
  machineListGetApi,
  machinePostApi,
  MachineRequestDto,
  MachineResponseDto,
  userListGetApi,
  UserType,
  workbayListGetApi,
  WorkbayType,
} from '../../../api/apiConfig';
import useFetch from '../../../api/useFetch';
import SquareButton from '../../../component/button/SquareButton';

const newDto = (data?: MachineResponseDto): MachineRequestDto => {
  return data
    ? {
        id: data.id,
        name: data.name || '',
        identifier: data.identifier || '',
        workbayId: data.workbay.id,
      }
    : {
        id: null,
        name: '',
        identifier: '',
        workbayId: -1,
      };
};

export const Machine = () => {
  const [machineData, setMachineData] = useState<MachineRequestDto>(newDto());

  const [workbayList, setWorkbayList] = useState<WorkbayType[]>([]);
  const [machineList, setMachineList] = useState<MachineResponseDto[]>([]);

  const { fetch: fetchWorkbayListGetApi } = useFetch({
    fetchFunction: workbayListGetApi,
    onSuccess: (data: WorkbayType[]) => setWorkbayList(data),
  });

  const { fetch: fetchMachineListGetApi } = useFetch({
    fetchFunction: machineListGetApi,
    onSuccess: (data: MachineResponseDto[]) => setMachineList(data),
  });

  const { fetch: fetchMachinePostApi } = useFetch({
    fetchFunction: machinePostApi,
    onSuccess: (data: MachineResponseDto) => {
      if (machineList.some((extMachine) => extMachine.id === data.id)) {
        setMachineList((prev) =>
          prev.map((extMachine) =>
            extMachine.id === data.id ? data : extMachine
          )
        );
      } else {
        setMachineList((prev) => [...prev, data]);
      }
    },
  });

  useEffect(() => {
    fetchWorkbayListGetApi();
    fetchMachineListGetApi();
  }, []);

  function saveHandler() {
    fetchMachinePostApi(machineData);
  }

  return (
    <Container>
      <HalfContainer style={{ overflow: 'hidden' }}>
        <HalfHead>
          {machineData.id ? '기계 정보 수정' : '기계 신규 등록'}

          <SquareButton
            colorType={
              machineData?.name.trim() !== '' && machineData?.workbayId !== -1
                ? 'ACTIVE'
                : 'DISACTIVE'
            }
            onClick={() =>
              machineData?.name.trim() !== '' && machineData?.workbayId !== -1
                ? saveHandler()
                : undefined
            }
            text={machineData.id ? '수정하기' : '등록하기'}
          />
        </HalfHead>
        <EditContent>
          <div className='row'>
            <div className='label'>기계 이름</div>
            <InputUnderline
              style={{ width: '250px' }}
              placeHolder='기계 이름을 입력해주세요'
              value={machineData.name}
              onChange={(text: string) =>
                setMachineData((prev) => ({ ...prev, name: text }))
              }
            />
          </div>
        </EditContent>
        <div style={{ height: '35px' }} />
        <EditContent>
          <div className='row'>
            <div className='label'>기계 식별자(선택)</div>
            <InputUnderline
              style={{ width: '250px' }}
              placeHolder='기계 식별자를 입력해주세요(선택)'
              value={machineData.identifier}
              onChange={(text: string) =>
                setMachineData((prev) => ({ ...prev, identifier: text }))
              }
            />
          </div>
        </EditContent>
        <div style={{ height: '35px' }} />
        <EditContent>
          <div className='row'>
            <div className='label'>작업장 선택</div>
            <WorkbayContainer>
              {workbayList.length > 0 &&
                workbayList
                  .filter((workbay) => workbay.workbayCode !== '100')
                  .map((workbay) => (
                    <WorkbayItem
                      $selected={machineData.workbayId === workbay.id}
                      onClick={() =>
                        setMachineData((prev) => ({
                          ...prev,
                          workbayId: workbay.id,
                        }))
                      }
                    >
                      {workbay.workbayName}
                    </WorkbayItem>
                  ))}
            </WorkbayContainer>
          </div>
        </EditContent>
      </HalfContainer>
      <HalfContainer>
        <HalfHead>
          기계 목록
          <SquareButton
            colorType={'ACTIVE'}
            onClick={() => setMachineData(newDto())}
            text='새로 만들기'
          />
        </HalfHead>
        <ListWrapper>
          {machineList.length > 0 &&
            machineList.map((machine, index) => (
              <>
                <ListItem
                  $selected={machineData?.id === machine.id}
                  onClick={() => setMachineData(newDto(machine))}
                >
                  <div className='row'>
                    <div className='label'>기계 이름</div>
                    <div className='value'>{machine.name}</div>
                  </div>
                  <div className='row'>
                    <div className='label'>기계 식별자</div>
                    <div className='value'>
                      {machine.identifier !== null &&
                      machine.identifier?.trim() !== ''
                        ? machine.identifier
                        : '-'}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='label'>작업장 정보</div>
                    <div className='value'>{machine.workbay.workbayName}</div>
                  </div>
                </ListItem>
                {index + 1 < machineList.length && <Division />}
              </>
            ))}
        </ListWrapper>
      </HalfContainer>
    </Container>
  );
};

const Container = styled.div`
  * {
    box-sizing: border-box;
  }
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 25px;
`;

const HalfContainer = styled.div`
  flex: 1;
  padding: 23px;
  height: 100%;
  overflow-y: scroll;
  background-color: white;
  display: flex;
  flex-direction: column;
`;

const HalfHead = styled.div`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.charcoal};
  font-weight: 600;
  margin-bottom: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const EditContent = styled.div`
  display: flex;
  flex-direction: column;
  > .row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 6px;

    .label {
      flex: 0 0 30px;
      font-size: 18px;
      color: ${({ theme }) => theme.colors.charcoal};
      font-weight: 600;
    }
  }
`;

const WorkbayContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.charcoal};
  width: 250px;
  overflow: hidden;
`;

const WorkbayItem = styled.div<{ $selected: boolean }>`
  user-select: none;
  text-align: start;
  cursor: pointer;
  padding: 10px;
  /* height: 24px; */
  width: 100%;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.colors.lightGray : 'transparent'};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;

const ListWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.charcoal};
  overflow: hidden;
`;

const ListItem = styled.div<{ $selected: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  background-color: ${({ $selected, theme }) =>
    $selected && theme.colors.lightGray};
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    .label {
      width: 100px;
      font-size: 14px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.charcoal};
    }
    .value {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

const Division = styled.div`
  height: 1px;
  width: 97%;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.charcoal};
`;
